import { AxiosError } from 'axios'
import { action, flow, makeObservable } from 'mobx'

import { STORE_UI } from 'Core/constants'
import { searchQueryConfig } from 'Core/constants/filters'
import { CoreUrlParams, SortingParams } from 'Core/interfaces'
import { TableStore } from 'Core/stores/tableStore/TableStore'
import { storagePageSizeConstant } from 'Core/utils/storeHelpers/storagePageSizeConstant'

import { UrlParams, UrlParamsLabel } from 'Portals/Customer/constants'
import { PurchaseOrder } from 'Portals/Customer/entities'
import { getFiltersConfig } from 'Portals/Customer/Pages/PurchaseOrder/TableList/Filters/utils'
import { getMainSearchConfig } from 'Portals/Customer/Pages/PurchaseOrder/TableList/Filters/utils'
import { PurchaseOrderRepo } from 'Portals/Customer/repositories'
import { RootStore } from 'Portals/Customer/stores'

const STORAGE_PURCHASE_ORDER_PAGE_SIZE = storagePageSizeConstant('purchaseOrder')

export class PurchaseOrderTable extends TableStore<PurchaseOrder.Basic> {
	constructor(private rootStore: RootStore) {
		super(STORAGE_PURCHASE_ORDER_PAGE_SIZE)
	}

	@flow.bound
	*getItems(defaultSort?: SortingParams) {
		try {
			yield this.requestData({
				repository: PurchaseOrderRepo.getList,
				defaultSort
			})
		} catch (error) {
			this.rootStore[STORE_UI].showErrorNotification(error as AxiosError)
		}
	}

	@action.bound
	initFromURLParams = (params: Record<string, string[]>) => {
		const searchKeys = [
			UrlParams.poId,
			UrlParams.poNumber,
			UrlParamsLabel.poIdLabel,
			UrlParamsLabel.poNumberLabel,
			CoreUrlParams.searchQuery
		]
		const filterKeys = [UrlParams.serviceSiteId, UrlParams.statusId]

		const mergedSearchConfig = {
			...getMainSearchConfig(),
			...searchQueryConfig
		}

		this.initSearchParamsFromUrl(params, searchKeys, mergedSearchConfig)
		this.initFilterParamsFromUrl(params, filterKeys, getFiltersConfig())
	}
}
